import { Select } from '@mantine/core'
import {
  ACCOUNTING_GROUP_BY_VALUES,
  ACCOUNTING_REPORT_VALUES,
  type AccountingGroupBy,
  type AccountingReport,
} from '@/model/middleware-types'
import { type AccountingView, effectiveGroupBy, GROUP_BY_LABELS, REPORT_LABELS } from './state'

export function ReportControls({
  view,
  onChange,
}: {
  view: AccountingView
  onChange: (next: AccountingView) => void
}) {
  const reportData = ACCOUNTING_REPORT_VALUES.map((value) => ({
    value,
    label: REPORT_LABELS[value],
  }))

  const groupByData = ACCOUNTING_GROUP_BY_VALUES.filter(
    (value) => value !== 'method' || view.report === 'payments',
  ).map((value) => ({ value, label: GROUP_BY_LABELS[value] }))

  return (
    <div className="flex flex-wrap gap-3">
      <Select
        label="Report details"
        data={reportData}
        value={view.report}
        onChange={(value) => value && onChange({ ...view, report: value as AccountingReport })}
        allowDeselect={false}
      />

      <Select
        label="Group by"
        data={groupByData}
        value={effectiveGroupBy(view)}
        onChange={(value) => value && onChange({ ...view, groupBy: value as AccountingGroupBy })}
        allowDeselect={false}
      />
    </div>
  )
}
